import { type ReactNode } from "react";

import {
  Modal as ReactAriaModal,
  type ModalOverlayProps as ReactAriaModalProps,
} from "react-aria-components";

import { customTv } from "#utils";

export type ModalSize = "sm" | "md" | "lg" | "xl";

export interface ModalProps extends ReactAriaModalProps {
  className?: string;
  children: ReactNode;
  size?: ModalSize;
}

const modalStyles = customTv({
  base: "border border-outline-decorative bg-background-primary shadow-lg overflow-auto max-h-[90vh] overscroll-none rounded-xl",
  variants: {
    size: {
      sm: "w-full max-w-[400px]",
      md: "w-full max-w-[560px]",
      lg: "w-full max-w-[720px]",
      xl: "w-full max-w-[900px]",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

export function Modal({ children, className, size = "md" }: ModalProps) {
  return <ReactAriaModal className={modalStyles({ size, className })}>{children}</ReactAriaModal>;
}
